import { requestTeamsF } from './requestTeamsF'

export const requestFlows = [requestTeamsF]
